import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux';
import { RootState } from '../reducers';
import { useDispatch } from 'react-redux';
import useEffectOnce from '../hooks/useEffectOnce';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { useNavigate } from 'react-router-dom';
import { Message } from 'primereact/message';
import { LoginService } from '../services/LoginService';
import { fetchCountryData, fetchRegionsData, getSpecialityData } from '../reduxactions/adminactions/AdminOfficerActions';
import { Card } from 'primereact/card';
import { Panel } from 'primereact/panel';
import { Admin_API } from '../ApiNames';
import { Dropdown, DropdownChangeEvent } from 'primereact/dropdown';
export const AdminOfficer = () => {
    const uid = window.sessionStorage.getItem('uid');

    const [globalFilter, setGlobalFilter] = useState('');

    const data = useSelector((state: RootState) => state.officer.get);

    const dispatch = useDispatch();


    const toast = useRef(data);

    //To get data
    const fetchDataAsync = async () => {
        try {
            await dispatch(getSpecialityData() as any);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const country = useSelector((state: RootState) => state.officer.country);

    const fetchCountryDatas = async () => {
        try {
            await dispatch(fetchCountryData() as any);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const dataregion = useSelector((state: RootState) => state.officer.region);

    const fetchReg = async () => {
        try {
            await dispatch(fetchRegionsData() as any);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    useEffectOnce(() => {
        fetchDataAsync();
        fetchReg();
        fetchCountryDatas();
    }, [dispatch]);
    const Close = () => {
        setaddDilog(false);

    }
    const [addDilog, setaddDilog] = useState(false);
    const OfficerList = [
        { label: 'Medical Officer', value: 'MEDICAL OFFICER' },
        { label: 'Finance Officer', value: 'FINANCE OFFICER' },
        { label: 'Consultancy Officer', value: 'CONSULTANCY_OFFICER' },
        { label: 'Doctor Approver', value: 'DOCTOR APPROVER' },
    ];
    const [role, setRole] = useState('');
    const [firstname, setFirstName] = useState('');
    const [lastname, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [countrys, setCountry] = useState('');
    const [region, setRegion] = useState('');
    const toast1 = useRef<Toast>(null);

    const addVolunteerDataAsync = async () => {
        if (!role || !firstname || !lastname) {
            toast.current.show({ severity: 'error', detail: 'Please fill in all required fields.', life: 3000 });
            return;
        }
        try {
            const payload = { role: role, fname: firstname, lname: lastname, email: email, phone: phone, country: countrys, region: region, q: 2 };
            const apiname = Admin_API.officer_API;
            const response = await LoginService.getData(apiname, payload);
            if (toast1.current) {
                toast1.current.show({ severity: 'success', detail: response });
            }
            fetchDataAsync();
            setaddDilog(false);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const [editData, setEditData] = useState(false);

    const [policeEdit, setPoliceEdit] = useState({
        firstname: '',
        lastname: '',
        email: '',
        phone: '',
        region: '',
        countrys: '',
        oid: '',
    });

    const groupadmin = (rowData: any) => {

        setPoliceEdit({
            firstname: rowData.first_name,
            lastname: rowData.last_name,
            email: rowData.email,
            phone: rowData.phone,
            region: rowData.region_ID,
            countrys: rowData.country_ID,
            oid: rowData.officer_ID,
        });
        setEditData(true);
    };
    const toast2 = useRef<Toast>(null);

    const makegroup = async () => {
        const { countrys, phone, region, oid } = policeEdit;
        try {
            const payload = { category: countrys, phone: phone, region: region, oid: oid, q: 3 };
            const apiname = Admin_API.officer_API;
            const response = await LoginService.getData(apiname, payload);
            if (toast2.current) {
                toast2.current.show({ severity: 'success', detail: 'Successfully Updated' });
            }
            fetchDataAsync();
            setEditData(false);
        } catch (error) {
            console.error('Error deleting data:', error);
        }
    };
    const [deleteConfirmation, setDeleteConfirmation] = useState(false);

    const [removedata, setRemoveData] = useState({
        oid: '',
    });

    const Removeduring = (rowData: any) => {
        setRemoveData({
            oid: rowData.officer_ID,
        });
        setDeleteConfirmation(true);
    }
    const toast3 = useRef<Toast>(null);

    const confirmDelete = async () => {
        const { oid } = removedata;
        const payload = { oid: oid, q: 4 };
        const apiname = Admin_API.officer_API;
        const data = await LoginService.getData(apiname, payload);
        if (toast3.current) {
            toast3.current.show({ severity: 'success', detail: data });
        }
        setDeleteConfirmation(false);
        fetchDataAsync()
    };
    //for help
    const [openHelp, setHelp] = useState(false);
    const url1 = window.sessionStorage.getItem("apiRoot");
    const IUrl = `${url1}/help/adminofficers.php`;
    const helpImg = `${url1}/help/help3.png`;
    const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
        event.preventDefault();
        const newWindowReference = window.open(
            targetUrl,
            'newwindow',
            'width=1000,height=1000,noopener,noreferrer'
        );

        if (newWindowReference) {
            newWindowReference.opener = null;
        }
    };
    return (
        <div className="admin-layout-container">
            <div className="content-wrapper" style={{ marginLeft: '100px' }}>
                <section className="content-header">
                    <div className="container-fluid">
                        <div className="grid mb-2">
                            <div className="col-6">
                            </div>
                        </div>
                    </div>
                </section>
                <section className="content" style={{ marginLeft: '110px' }} >
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card-header p-2" style={{ marginTop: '50px' }}>
                                <h2>Officer List</h2>
                            </div>
                            <div className="col-16" style={{ textAlign: "right" }}>
                                <a
                                    title="help"
                                    onClick={(e) => openWindow(e, IUrl)}
                                    style={{

                                        color: "blue",
                                        fontSize: 15, cursor: "pointer"
                                    }}
                                >Help for this Page &nbsp;
                                    <i style={{ marginTop: 40, backgroundColor: "orange", color: "white" }} className="pi pi-question-circle"></i>

                                </a>
                            </div>
                            <br></br>
                            <div className="card flex flex-wrap justify-content-end" style={{ marginRight: '30px' }}>
                                <Button label="Add Officer" severity="info" onClick={() => setaddDilog(true)} />
                            </div>
                            <div className="box box-primary">
                                <div className="card">
                                    <p className="m-0">
                                        <div>
                                            <div className="card flex flex-wrap justify-content">
                                                <span className="p-input-icon-left">
                                                    <i className="pi pi-search" style={{ paddingLeft: '5px' }} />
                                                    <InputText value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Global Search" style={{ paddingLeft: '25px' }} />
                                                </span>

                                            </div>
                                            <DataTable value={data} stripedRows paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]} tableStyle={{ minWidth: '50rem' }} filters={{ global: { value: globalFilter, matchMode: 'contains' } }}
                                                globalFilterFields={['first_name', 'last_name', 'Role', 'officer_type', 'email']} >
                                                <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>
                                                <Column body={(rowData) => `${rowData.first_name} ${rowData.last_name}`} sortable header="Name"></Column>
                                                <Column field="email" sortable header="Email"></Column>
                                                <Column header="Role" sortable body={(rowData) => rowData.officer_type ? rowData.officer_type.charAt(0).toUpperCase() + rowData.officer_type.slice(1).toLowerCase() : ''}
                                                />

                                                <Column header="Status" sortable body={(rowData) => rowData.status ? rowData.status.charAt(0).toUpperCase() + rowData.status.slice(1).toLowerCase() : ''}
                                                />
                                                <Column header="Operation" body={(rowData) => (
                                                    <>

                                                        <Button className='mr-1' tooltip="Edit" severity="info" icon="pi pi-pencil" rounded outlined onClick={() => groupadmin(rowData)} />
                                                        <Button className='mr-6' tooltip="Delete" severity="danger" icon="pi pi-trash" rounded outlined onClick={() => Removeduring(rowData)} />
                                                    </>
                                                )} />
                                            </DataTable>

                                        </div>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            <Dialog header="Add Officer" visible={addDilog} style={{ width: '34vw', height: '74vh' }} onHide={() => setaddDilog(false)} >
                <div className="grid pt-1" >
                    <div className="col-3">
                        <label htmlFor="name" className="col-sm-2 control-label">Role:</label>
                    </div>
                    <div className="col-6" >
                        <Dropdown id="type" value={role} onChange={(e) => setRole(e.value)} className="custom-dropdown-placeholder" options={OfficerList} optionLabel="label" optionValue="value" placeholder="Select a Role" style={{ width: '18vw', marginLeft: '25px' }} />
                    </div>
                </div>

                <div className="grid pt-1" >
                    <div className="col-3">
                        <label htmlFor="name" className="col-sm-2 control-label">First Name:</label>
                    </div>
                    <div className="col-6" >
                        <InputText
                            id="name"
                            style={{ width: '18vw', marginLeft: '25px' }}
                            name="Contest Name"
                            placeholder='Enter FirstName'
                            onChange={(e) => setFirstName(e.target.value)}
                        />
                    </div>
                </div>

                <div className="grid pt-0" >
                    <div className="col-3">
                        <label htmlFor="name" className="col-sm-2 control-label">Last Name:</label>
                    </div>
                    <div className="col-6" >
                        <InputText
                            id="name"
                            style={{ width: '18vw', marginLeft: '25px' }}
                            name="Contest Name"
                            placeholder='Enter LastName'
                            onChange={(e) => setLastName(e.target.value)}
                        />

                    </div>
                </div>
                <div className="grid pt-0" >
                    <div className="col-3">
                        <label htmlFor="name" className="col-sm-2 control-label">Officer Email:</label>
                    </div>
                    <div className="col-6" >
                        <InputText
                            id="name"
                            style={{ width: '18vw', marginLeft: '25px' }}
                            name="Contest Name"
                            placeholder='Enter Email'
                            onChange={(e) => setEmail(e.target.value)}
                        />
                    </div>
                </div>

                <div className="grid pt-0" >
                    <div className="col-3">
                        <label htmlFor="name" className="col-sm-2 control-label">Phone Number:</label>
                    </div>
                    <div className="col-6" >
                        {/* <InputText
                            id="name"
                            style={{ width: '18vw', marginLeft: '25px' }}
                            name="Contest Name"
                            placeholder='Enter Phone'
                            onChange={(e) => setPhone(e.target.value)}
                        />
                           */}
                           <InputText
    id="phone"
    type="tel"
    maxLength={10}
    inputMode="numeric"
    pattern="[0-9]{10}"
    placeholder="Enter 10-digit Phone"
    style={{ width: '18vw', marginLeft: '25px' }}
    value={phone}
    onChange={(e) => {
        const value = e.target.value.replace(/\D/g, '');
        if (value.length <= 10) {
            setPhone(value);
        }
    }}
/>
{/*
 * Author: Anuradha ,Date: 2026-02-05 
 * Description:phonenumber enni numbers ichina teeskuntundi
 */}




                    </div>
                </div>

                <div className="grid pt-0" >
                    <div className="col-3">
                        <label htmlFor="name" className="col-sm-2 control-label">Country:</label>
                    </div>
                    <div className="col-6" >
                        <Dropdown id="type" value={countrys} onChange={(e) => setCountry(e.value)} className="custom-dropdown-placeholder" options={country} optionLabel="name" optionValue="countryids" placeholder="Select a Country" style={{ width: '18vw', marginLeft: '25px' }} />
                    </div>
                </div>
                <div className="grid pt-0" >
                    <div className="col-3">
                        <label htmlFor="name" className="col-sm-2 control-label">Region :</label>
                    </div>
                    <div className="col-6" >
                        <Dropdown id="type" value={region} onChange={(e) => setRegion(e.value)} className="custom-dropdown-placeholder" options={dataregion} optionLabel="region_name" optionValue="region_ID" placeholder="Select a Region" style={{ width: '18vw', marginLeft: '25px' }} />
                    </div>
                </div>
                <Button label="Close" onClick={Close} severity="secondary" />
                <Button label="Add" onClick={addVolunteerDataAsync} style={{ float: 'right' }} />
            </Dialog >
            <Dialog header="Edit Officer" visible={editData} style={{ width: '34vw', height: '72vh' }} onHide={() => setEditData(false)} >
                <div className="grid pt-0" style={{ marginBottom: '2px' }}>
                    <div className="col-3">
                        <label htmlFor="name" className="col-sm-2 control-label">First Name:</label>
                    </div>
                    <div className="col-6" >
                        <InputText id="name" style={{ width: '18vw', marginBottom: '6px' }} name="Contest Name" placeholder='Enter Station Name ' onChange={(e) => setPoliceEdit({ ...policeEdit, firstname: e.target.value })} value={policeEdit.firstname} disabled />
                    </div>
                </div>

                <div className="grid pt-0" style={{ marginBottom: '2px' }}>
                    <div className="col-3">
                        <label htmlFor="name" className="col-sm-2 control-label">Last Name:</label>
                    </div>
                    <div className="col-6" >
                        <InputText id="amount" style={{ width: '18vw', marginBottom: '6px' }} name="amount" placeholder='Enter Officer Name' onChange={(e) => setPoliceEdit({ ...policeEdit, lastname: e.target.value })} value={policeEdit.lastname} disabled />
                    </div>
                </div>

                <div className="grid pt-0" style={{ marginBottom: '2px' }}>
                    <div className="col-3">
                        <label htmlFor="name" className="col-sm-2 control-label"> Email:</label>
                    </div>
                    <div className="col-6" >
                        <InputText id="amount" style={{ width: '18vw', marginBottom: '6px' }} name="amount" placeholder='Enter Email' onChange={(e) => setPoliceEdit({ ...policeEdit, email: e.target.value })} value={policeEdit.email} />
                    </div>
                </div>
                <div className="grid pt-0" style={{ marginBottom: '2px' }}>
                    <div className="col-3">
                        <label htmlFor="name" className="col-sm-2 control-label">Phone :</label>
                    </div>
                    <div className="col-6" >
                        {/* <InputText id="amount" style={{ width: '18vw', marginBottom: '6px' }} placeholder='Enter Phone' name="amount" onChange={(e) => setPoliceEdit({ ...policeEdit, phone: e.target.value })} value={policeEdit.phone} /> */}
                        
                                                       <InputText
    id="phone"
    type="tel"
    maxLength={10}
    inputMode="numeric"
    pattern="[0-9]{10}"
    placeholder="Enter 10-digit Phone"
    style={{ width: '18vw', marginBottom: '6px' }}
    value={policeEdit.phone}
    onChange={(e) => {
        const value = e.target.value.replace(/\D/g, '');
        if (value.length <= 10) {
            setPoliceEdit({ ...policeEdit, phone: value });
        }
    }}
/>
{/*
 * Author: Anuradha ,Date: 2026-02-05 
 * Description: phonenumber 10digits
 */}




                    </div>
                </div>

                <div className="grid pt-0" style={{ marginBottom: '2px' }}>
                    <div className="col-3">
                        <label htmlFor="name" className="col-sm-2 control-label"> Country:</label>
                    </div>
                    <div className="col-6" >
                        <Dropdown
                            id="country"
                            value={policeEdit.countrys}
                            onChange={(e: DropdownChangeEvent) => setPoliceEdit({ ...policeEdit, countrys: e.target.value })}
                            options={country}
                            optionLabel="name"
                            optionValue="countryids"
                            placeholder="Select a Country"
                            className="custom-dropdown-placeholder"
                            style={{ width: '18vw', marginBottom: '6px' }}
                        />
                    </div>
                </div>

                <div className="grid pt-0" style={{ marginBottom: '2px' }}>
                    <div className="col-3">
                        <label htmlFor="name" className="col-sm-2 control-label">Region:</label>
                    </div>
                    <div className="col-6" >
                        <Dropdown
                            id="regionname"
                            value={policeEdit.region}
                            onChange={(e: DropdownChangeEvent) => setPoliceEdit({ ...policeEdit, region: e.target.value })}
                            options={dataregion}
                            optionLabel="region_name"
                            optionValue="region_ID"
                            placeholder="Select a Region"
                            className="custom-dropdown-placeholder"
                            style={{ width: '18vw', marginBottom: '6px' }}
                        />
                    </div>


                </div>
                <Button label="Close" onClick={() => setEditData(false)} severity="secondary" />
                <Button label="Update" onClick={makegroup} style={{ float: 'right' }} />
            </Dialog >
            < Dialog header="Conform Delete " style={{ width: '30vw' }} visible={deleteConfirmation} onHide={() => setDeleteConfirmation(false)}>
                <div>Are you really want to Remove...?</div>
                <br></br>
                <Button label="Close" onClick={() => setDeleteConfirmation(false)} className="mr-3 p-button-secondary" />
                <Button label="Delete" className='mr-3 p-button-raised' onClick={confirmDelete} />
            </Dialog >

            <Toast ref={toast3} ></Toast>
            <Toast ref={toast1} ></Toast>
            <Toast ref={toast2} ></Toast>

        </div>
    )
}
